import type { PlatformLifecycle } from "@orb-labs/orby-react";

export const webPlatformLifecycle: PlatformLifecycle = {
  useIsActive: () => true,
};
